export const /** @type {?} */ TNK_LOAN_DATA = '_tnkLoanData';